'use client';

import { Grid, Cell } from '@faceless-ui/css-grid';
import React from 'react';
import { useWindowInfo } from '@faceless-ui/window-info';
import styles from './styles.module.scss';

import type { PagesQuery } from '../../graphql/generated/schema';
import { BlockSettings_Margin_MarginBottom, BlockSettings_Padding_PaddingLeft, BlockSettings_Padding_PaddingRight } from '../../graphql/generated/schema';
import { BlockContainer } from '../../components/layouts';
import { RenderBlocks } from '../../components/RenderBlocks';
import type { ExtractLayoutType, SharedBlockType } from '../types';
import { constructClassName } from '../../utils/constructClassName';
import { toCapitalCase } from '../../utils/changeCase';
import breakpoints from '../../styles/queries/index.module.scss';
import { SlideInContainer } from '../../components/animatedContainers';

const colStyles = {
  full: {
    cols: 12,
  },
  half: {
    cols: 6,
    colsL: 12,
  },
  quarter: {
    cols: 3,
    colsL: 6,
    colsM: 12,
  },
  third: {
    cols: 4,
    colsM: 6,
  },
  twoThirds: {
    cols: 8,
  },
};

export const Columns: React.FC<SharedBlockType & ExtractLayoutType<PagesQuery, 'Columns'>> = ({
  columns,
  settings,
  hasDarkBackground,
  blockSettings,
}) => {
  const { width } = useWindowInfo();
  const isMobile = (width || 0) <= parseInt(breakpoints.md, 10);

  return (
    <BlockContainer
      blockSettings={blockSettings}
    >
      <Grid
        className={constructClassName([
          styles[`gap${toCapitalCase(settings?.columnGapSize || 'small')}` as keyof typeof styles],
          styles.gridContainer,
        ])}
      >
        {
          ((isMobile && settings?.flipOnMobile) ? [...columns || []].reverse() : columns)?.map((column, index) => column.columnWidth && (
            <Cell
              key={column.id}
              {...colStyles[column.columnWidth]}
              className={constructClassName([
                styles.cellContainer,
                styles[`alignCell${toCapitalCase(settings?.verticalAlignment || 'center')}` as keyof typeof styles],
              ])}
            >
              <SlideInContainer
                delay={index * 100}
              >
                {
                  column.blocks && (
                    <RenderBlocks
                      blocks={column.blocks}
                      hasDarkBackground={hasDarkBackground}
                      blockSettings={{
                        margin: {
                          // eslint-disable-next-line camelcase
                          marginBottom: BlockSettings_Margin_MarginBottom.None,
                        },
                        padding: {
                          // eslint-disable-next-line camelcase
                          paddingLeft: BlockSettings_Padding_PaddingLeft.None,
                          // eslint-disable-next-line camelcase
                          paddingRight: BlockSettings_Padding_PaddingRight.None,
                        },
                      }}
                    />
                  )
                }
              </SlideInContainer>
            </Cell>
          ))
        }
      </Grid>
    </BlockContainer>
  );
};
